<template>
  <div class="tag-manager">
    <router-view></router-view>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>